import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent } from '../level.components'
import challengeNumberUtils from './utils/challengeNumber.utils'
import { buildLevel } from '../../../services/game.services'



export default class ChallengeLevelComponent extends BaseLevel {
    flashTimeout = null
    challengeInterval = null
    state = {
        answer: '?',
        wrongAnswer: false,
        flash: false,
        timer: 60,
        countdown: 3,
    }
    componentWillMount() {
        this.generateLevel()
        this.challengeInterval = setInterval(this.onTimer, 1000)
        document.addEventListener("keydown", this.onKeyPress);
    }
    componentWillUnmount() {
        clearTimeout(this.flashTimeout)
        clearInterval(this.challengeInterval)
        document.removeEventListener("keydown", this.onKeyPress);
    }
    onTimer = () => {
        if (!this.props.paused) {
            if (this.state.countdown > 0) {
                this.setState({ countdown: this.state.countdown - 1 })
            } else {
                let timer = this.state.timer - 1 >= 0 ? this.state.timer - 1 : 0
                if (timer <= 0) {
                    this.props.onLevelComplete()
                    this.setState({ timer: 60 })
                } else {
                    this.setState({ timer })
                }
            }
        }
    }
    generateLevel = () => {
        const levelConfig = this.state.nextLevelConfig ? this.state.nextLevelConfig : buildLevel(this.props.level)
        const nextLevelConfig = buildLevel(this.props.level)
        this.setState({ ...levelConfig, nextLevelConfig })
    }
    onEnter = () => {
        const answerRequired = this.props.level.settings.answer_required
        let result = 0
        if (answerRequired === 'value_1') {
            result = this.state.quantities.value_1
        } else if (answerRequired === 'value_2') {
            result = this.state.quantities.value_2
        } else if (answerRequired === 'value_3') {
            result = this.state.quantities.value_3
        } else {
            if (this.state.operation === 'addition') {
                result = +this.state.quantities.value_1 + +this.state.quantities.value_2 + +this.state.quantities.value_3
            }else{
                result = +this.state.quantities.value_1 - this.state.quantities.value_2 - this.state.quantities.value_3
            }
        }
        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        const settings = level.settings
        const quantities = this.state.quantities
        const quantitiesNext = this.state.nextLevelConfig.quantities
        const timer = this.state.timer
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const answerRequired = settings.answer_required || 'answer'
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight

        return (
            <BaseLevelLayoutComponent level={level} timer={timer} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} togglePause={this.props.togglePause} stage={stage} answer={answer} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {this.state.countdown > 0 ?
                        (<span className='level-countdown'> {this.state.countdown} </span>) :
                        gameContainerHeight > 0 && challengeNumberUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, quantitiesNext, answer, timer)
                    }
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/challenge.levels.js